"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiLink = void 0;
var colors_1 = require("../../generated/colors");
exports.MuiLink = {
    defaultProps: {
        underline: "always",
    },
    styleOverrides: {
        root: {
            color: colors_1.colors.TextLink,
            textDecorationColor: colors_1.colors.TextLink,
        },
    },
};
//# sourceMappingURL=link.js.map